import {
	ComponentPropsWithoutRef,
	ElementRef,
	forwardRef,
	useEffect,
	useState
} from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@/lib/classNames';

export const RangeSlider = forwardRef<
	ElementRef<typeof SliderPrimitive.Root>,
	ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, defaultValue = [0, 40], ...props }, ref) => {
	const { disabled } = props;

	const [value, setValue] = useState(defaultValue);

	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	const handleChange = (newValue: number[]) => {
		setValue(newValue);
	};

	return (
		<div className="relative flex w-full flex-col">
			<SliderPrimitive.Root
				ref={ref}
				className={cn(
					'relative flex w-full touch-none select-none items-center py-4',
					className
				)}
				value={value}
				onValueChange={handleChange}
				{...props}
			>
				<SliderPrimitive.Track
					data-is-disabled={disabled}
					className="relative h-1 w-full grow overflow-hidden rounded-full bg-orange/20 data-[is-disabled=true]:bg-dm-strong-mid-grey/20"
				>
					<SliderPrimitive.Range
						data-is-disabled={disabled}
						className="absolute h-full bg-orange data-[is-disabled=true]:pointer-events-none data-[is-disabled=true]:bg-dm-strong-mid-grey"
					/>
				</SliderPrimitive.Track>

				{value.map((val, index) => (
					<SliderPrimitive.Thumb
						// eslint-disable-next-line react/no-array-index-key
						key={`thumb_${index}`}
						data-is-disabled={disabled}
						className="block h-3 w-3 cursor-grab rounded-full border border-orange/50 bg-orange shadow transition-colors focus-visible:outline-none focus-visible:ring-1 active:cursor-grabbing data-[is-disabled=true]:pointer-events-none data-[is-disabled=true]:border-dm-strong-mid-grey data-[is-disabled=true]:bg-dm-strong-mid-grey"
					/>
				))}
			</SliderPrimitive.Root>

			<section
				data-is-disabled={disabled}
				className="flex items-center justify-between text-xs text-dm-white data-[is-disabled=true]:text-dm-strong-mid-grey"
			>
				<p className="inline-flex items-center justify-center whitespace-nowrap">
					Min: {value.at(0)} mi
				</p>

				<p className="inline-flex items-center justify-center whitespace-nowrap">
					Max: {value.at(-1)} mi
				</p>
			</section>
		</div>
	);
});

RangeSlider.displayName = SliderPrimitive.Root.displayName;
